<template>
  <div>
    <!-- partial:../../partials/_navbar.html -->
    <div class="horizontal-menu">
      <nav
        class="navbar top-navbar"
        style="
          height: fit-content;
          background-color: #ab0635;
          padding-top: 10px;
        ">
        <div class="container">
          <div class="navbar-content">
            <a
              href="#"
              class="navbar-brand"
              style="padding-top: 1.2% !important">
              <img
                src="/assets/images/getsitelogo.png"
                alt="LINC MIDDLEWARE"
                :width="40"
                :height="40" /><span
                class="m-1"
                style="color: white; font-weight: lighter">
                LINC MIDDLEWARE</span
              >
            </a>
            <ul class="navbar-nav">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="languageDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <div v-if="this.locale == 'id'">
                    <i
                      class="flag-icon flag-icon-id mt-1"
                      title="indonesia"></i>
                    <span
                      class="ms-1 me-1 d-none d-md-inline-block"
                      style="color: white; font-weight: lighter"
                      >Indonesia</span
                    >
                  </div>
                  <div v-else>
                    <i class="flag-icon flag-icon-us mt-1" title="us"></i>
                    <span
                      class="ms-1 me-1 d-none d-md-inline-block"
                      style="color: white; font-weight: lighter"
                      >English</span
                    >
                  </div>
                </a>
                <div class="dropdown-menu" aria-labelledby="languageDropdown">
                  <a @click="langChanged('en')" class="dropdown-item py-2"
                    ><i class="flag-icon flag-icon-us" title="us" id="us"></i>
                    <span
                      class="ms-1"
                      style="color: black; font-weight: lighter">
                      English
                    </span></a
                  >
                  <a @click="langChanged('id')" class="dropdown-item py-2"
                    ><i
                      class="flag-icon flag-icon-id"
                      title="indonesia"
                      id="id"></i>
                    <span
                      class="ms-1"
                      style="color: black; font-weight: lighter">
                      Indonesia
                    </span></a
                  >
                </div>
              </li>

              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="profileDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="me-2 icon-md text-light" data-feather="user"></i>
                </a>
                <div
                  class="dropdown-menu p-0"
                  aria-labelledby="profileDropdown">
                  <div
                    class="d-flex flex-column align-items-center border-bottom px-5 py-3">
                    <div class="text-center">
                      <p class="tx-16 fw-bolder">{{ this.name }}</p>
                      <p class="tx-12 text-muted">{{ this.email }}</p>
                    </div>
                  </div>
                  <ul class="list-unstyled p-1">
                    <li class="dropdown-item py-2">
                      <a href="#" @click="userProfile()" class="text-body ms-0">
                        <i class="me-2 icon-md" data-feather="user"></i>
                        <span>{{ $t("txtMyProfile") }}</span>
                      </a>
                    </li>
                    <li class="dropdown-item py-2">
                      <a
                        href="#"
                        @click="changePassword()"
                        class="text-body ms-0">
                        <i class="me-2 icon-md" data-feather="edit"></i>
                        <span>{{ $t("changePassword") }}</span>
                      </a>
                    </li>

                    <li class="dropdown-item py-2">
                      <a href="#" @click="logout()" class="text-body ms-0">
                        <i class="me-2 icon-md" data-feather="log-out"></i>
                        <span>{{ $t("txtSignOut") }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <button
              class="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
              type="button"
              data-toggle="horizontal-menu-toggle">
              <i data-feather="menu"></i>
            </button>
          </div>
        </div>
      </nav>

      <nav class="bottom-navbar">
        <div class="container">
          <ul class="nav page-navigation justify-content-evenly">
            <li class="nav-item">
              <a
                class="nav-link"
                href="/dashboard-billing"
                v-if="user_type == 'BILLING'">
                <i class="link-icon" data-feather="box"></i>
                <span class="menu-title">{{ $t("dashboardMenu") }}</span>
              </a>
              <a v-else class="nav-link" href="/dashboard">
                <i class="link-icon" data-feather="box"></i>
                <span class="menu-title">{{ $t("dashboardMenu") }}</span>
              </a>
            </li>

            <!--BILLING-->
            <li
              class="nav-item mega-menu"
              v-if="
                this.user_type == 'BILLING' ||
                this.user_type == 'BILLING_EXIM' ||
                this.role == 'superadmin_custom' ||
                this.role == 'superadmin'
              ">
              <a href="#" class="nav-link h4">
                <i class="link-icon mdi mdi-calculator"></i>
                <span class="menu-title">Billing</span>
                <i class="link-arrow"></i>
              </a>
              <div class="submenu">
                <div class="row">
                  <div class="col-md-3" v-if="this.billing_cml === 1">
                    <ul
                      class="submenu-item"
                      v-if="
                        (this.user_type == 'BILLING' && this.role_om !== 1) ||
                        this.role == 'superadmin_custom' ||
                        this.role == 'superadmin'
                      ">
                      <li class="category-heading">CML</li>
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'MasterWarehouseCmlController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cml/master-warehouse"
                            >{{ $t("MasterWarehouseTxt") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'MasterCustomerCmlController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cml/master-customer"
                            >{{ $t("MasterCustomerTxt") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'BmCodelkupCMLController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cml/bm-code-lkup"
                            >{{ $t("BmCodelkupTxt") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'BmTarifMasterHeaderController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cml/master-tarif"
                            >{{ $t("tarifMasterTxt") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'RatebaseCmlController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/billing-cml/ratebase">{{
                            $t("rateBase_txt")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'MasterLocationCmlController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cml/master-locations"
                            >{{ $t("masterLocations") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'RateHeaderCmlController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cml/rates/header"
                            >{{ $t("rate_txt") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'BillingCmlController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cml/billing/header"
                            >{{ $t("billing_txt") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'StorageEstimationController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cml/storage-estimation"
                            >{{ $t("storage_estimation") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'BmWmsCodeController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/billing-cml/wms-code">{{
                            $t("wms_code")
                          }}</a>
                        </li>
                      </span>
                    </ul>
                    <!-- role om_basf -->
                    <!--
                    <ul
                      class="submenu-item"
                      v-if="
                        this.user_type == 'BILLING' &&
                        this.role == 'om_cml_basf01'
                      ">
                      <li class="category-heading">CML</li>
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'BillingCmlController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cml/billing/header/BASF01"
                            >{{ $t("billing_txt") }}</a
                          >
                        </li>
                      </span>
                    </ul>
                    <ul
                      class="submenu-item"
                      v-if="
                        this.user_type == 'BILLING' &&
                        this.role == 'om_cml_basf02_rm'
                      ">
                      <li class="category-heading">CML</li>
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'BillingCmlController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cml/billing/header/BASF02RM"
                            >{{ $t("billing_txt") }}</a
                          >
                        </li>
                      </span>
                    </ul>
                    <ul
                      class="submenu-item"
                      v-if="
                        this.user_type == 'BILLING' &&
                        this.role == 'om_cml_basf02_fg'
                      ">
                      <li class="category-heading">CML</li>
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'BillingCmlController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cml/billing/header/BASF02FG"
                            >{{ $t("billing_txt") }}</a
                          >
                        </li>
                      </span>
                    </ul>
                    -->
                  </div>

                  <div class="col-md-3" v-if="this.mapping_role_user_billing === 1">
                    <ul class="submenu-item">
                      <li class="category-heading">Mapping Role</li>
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'MappingRoleUserBillingController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/billing-mapping/role-access/">{{
                            $t("role_access_warehouse")
                          }}</a>
                        </li>
                      </span>
                    </ul>
                  </div>

                  <div class="col-md-3" v-if="this.billing_cli === 1">
                    <ul class="submenu-item">
                      <li class="category-heading">CLI</li>
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'BmCodelkupController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/billing-bm-code-lkup">{{
                            $t("BmCodelkupTxt")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'MasterWarehouseCliController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cli-master-warehouse"
                            >{{ $t("MasterWarehouseTxt") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'MasterCustomerCliController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/billing-cli-master-customer"
                            >{{ $t("MasterCustomerTxt") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'RateCliController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/billing-cli-rate">{{
                            $t("rate_txt")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'BtBillingHeaderController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/billing-cli-billing">{{
                            $t("billing_txt")
                          }}</a>
                        </li>
                      </span>
                    </ul>
                  </div>

                  <div class="col-md-3" v-if="this.billing_exim === 1">
                    <ul class="submenu-item">
                      <li class="category-heading">EXIM</li>
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'EximMasterFreightController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/billing/exim/master-freight">{{
                            $t("MasterFreightTxt")
                          }}</a>
                        </li>
                        
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'EximBillingController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/billing/exim/transaction">{{
                            $t("billing_txt")
                          }}</a>
                        </li>

                      </span>
                    </ul>
                  </div>

                </div>
              </div>
            </li>

            <!-- SALES FORCE -->
            <li
              class="nav-item"
              v-if="
                this.sales_force === 1 ||
                this.role == 'superadmin_custom' ||
                this.role == 'superadmin'
              ">
              <a href="#" class="nav-link h4">
                <i class="link-icon mdi mdi-sale"></i>
                <span class="menu-title">{{ $t("sales_force") }}</span>
                <i class="link-arrow"></i>
              </a>
              <div class="submenu">
                <ul class="submenu-item">
                  <span
                    v-for="permision in permision_role"
                    :key="permision.permission_role_id">
                    <li
                      class="nav-item"
                      v-if="
                        permision.permission !== null &&
                        permision.permission.controller ==
                          'SalesForceBillingController' &&
                        permision.method_read == 1
                      ">
                      <a
                        class="nav-link"
                        href="/sales_force/opportunity_billing/header"
                        >{{ $t("billing_opportunity") }}</a
                      >
                    </li>
                  </span>
                </ul>
              </div>
            </li>

            <!-- WHATSAPP -->
            <li
              class="nav-item"
              v-if="
                this.role == 'superadmin' ||
                this.role == 'superadmin_custom' ||
                this.user_type == 'WHATSAPP'
              ">
              <a href="#" class="nav-link h4">
                <i class="link-icon mdi mdi-whatsapp"></i>
                <span class="menu-title">{{ $t("whatsapp") }}</span>
                <i class="link-arrow"></i>
              </a>
              <div class="submenu">
                <ul class="submenu-item">
                  <span
                    v-for="permision in permision_role"
                    :key="permision.permission_role_id">
                    <li
                      class="nav-item"
                      v-if="
                        permision.permission !== null &&
                        permision.permission.controller ==
                          'WaMasterPhoneNumberController' &&
                        permision.method_read == 1
                      ">
                      <a
                        class="nav-link"
                        href="/whatsapp/master-phone-number"
                        >{{ $t("master_phone_number") }}</a
                      >
                    </li>
                    <li
                      class="nav-item"
                      v-if="
                        permision.permission !== null &&
                        permision.permission.controller ==
                          'WaMessageController' &&
                        permision.method_read == 1
                      ">
                      <a class="nav-link" href="/whatsapp/message-data">{{
                        $t("message_data")
                      }}</a>
                    </li>
                  </span>
                </ul>
              </div>
            </li>

            <!-- BLUJAY -->
            <li
              class="nav-item"
              v-if="
                this.role == 'superadmin' ||
                this.role == 'superadmin_custom' ||
                this.role == 'superadmin_customwmsbj' ||
                this.user_type == 'BLUJAY' ||
                this.user_type == 'BLUJAY_BCA'
              ">
              <a href="#" class="nav-link h3">
                <!--<i class="link-icon" data-feather="truck"></i>-->
                <i class="link-icon mdi mdi-truck-fast-outline"></i>
                <span class="menu-title">{{ $t("blujay") }}</span>
                <i class="link-arrow"></i>
              </a>
              <div class="submenu">
                <ul class="submenu-item">
                  <span
                    v-for="permision in permision_role"
                    :key="permision.permission_role_id">
                    <li
                      class="nav-item"
                      v-if="
                        permision.permission !== null &&
                        permision.permission.controller ==
                          'BlujayChainController' &&
                        permision.method_read == 1
                      ">
                      <a class="nav-link" href="/blujay/chain">{{
                        $t("chain")
                      }}</a>
                    </li>
                    <li
                      class="nav-item"
                      v-if="
                        permision.permission !== null &&
                        permision.permission.controller ==
                          'BlujayGsoftController' &&
                        permision.method_read == 1
                      ">
                      <a class="nav-link" href="/blujay/gsoft">GSOFT</a>
                    </li>
                    <li
                      class="nav-item"
                      v-if="
                        permision.permission !== null &&
                        permision.permission.controller ==
                          'BankTransactionsController' &&
                        permision.method_read == 1
                      ">
                      <a class="nav-link" href="/blujay-bca/transactions">{{
                        $t("bca")
                      }}</a>
                    </li>
                  </span>
                </ul>
              </div>
            </li>

            <!-- FLUX OMS -->
            <li
              class="nav-item mega-menu"
              v-if="
                this.role == 'superadmin' ||
                this.role == 'superadmin_custom' ||
                this.role == 'superadmin_customwmsbj' ||
                this.user_type == 'FLUX_OMS' ||
                this.user_type == 'MIDDLEWARE' || this.fluxOms
              ">
              <a href="#" class="nav-link h4">
                <i class="link-icon mdi mdi-dropbox"></i>
                <span class="menu-title">{{ $t("flux_oms") }}</span>
                <i class="link-arrow"></i>
              </a>
              <div class="submenu">
                <div class="col-group-wrapper row">
                  <div class="col-group col-md-2">
                    <p class="category-heading">Master Data</p>

                    <ul class="submenu-item">
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'SkuController' && permision.method_read == 1
                          ">
                          <a class="nav-link" href="/flux-oms/master-sku"
                            >SKU</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'InventoryController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/flux-oms/inventory"
                            >Inventory</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'InventoryController' &&
                            permision.method_custom1 == 1
                          ">
                          <a class="nav-link" href="/flux-oms/inventory-summary"
                            >Inventory Summary</a
                          >
                        </li>
                      </span>
                    </ul>
                  </div>

                  <div class="col-group col-md-2">
                    <p class="category-heading">Vendor</p>

                    <ul class="submenu-item">
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'VendorController' && permision.method_read == 1
                          ">
                          <a class="nav-link" href="/flux-oms/vendor">{{
                            $t("list")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'VendorController' && permision.method_create == 1
                          ">
                          <a class="nav-link" href="/flux-oms/vendor/create">{{
                            $t("CreateTxt")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'VendorController' && permision.method_upload == 1
                          ">
                          <a class="nav-link" href="/flux-oms/vendor/upload">{{
                            $t("UploadTxt")
                          }}</a>
                        </li>
                      </span>
                    </ul>
                  </div>

                  <div class="col-group col-md-2">
                    <p class="category-heading">{{ $t("outbound") }}</p>

                    <ul class="submenu-item">
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller == 'SoController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/flux-oms/so-outbound">{{
                            $t("list")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller == 'SoController' &&
                            permision.method_create == 1
                          ">
                          <a
                            class="nav-link"
                            href="/flux-oms/so-outbound/create"
                            >{{ $t("CreateTxt") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller == 'SoController' &&
                            permision.method_upload == 1
                          ">
                          <a
                            class="nav-link"
                            href="/flux-oms/so-outbound/upload"
                            >{{ $t("UploadTxt") }}</a
                          >
                        </li>
                      </span>
                    </ul>
                  </div>
                  <div class="col-group col-md-2">
                    <p class="category-heading">{{ $t("inbound_po") }}</p>
                    <ul class="submenu-item">
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller == 'PoController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/flux-oms/po-inbound">{{
                            $t("list")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller == 'PoController' &&
                            permision.method_create == 1
                          ">
                          <a
                            class="nav-link"
                            href="/flux-oms/po-inbound/create"
                            >{{ $t("CreateTxt") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller == 'PoController' &&
                            permision.method_upload == 1
                          ">
                          <a
                            class="nav-link"
                            href="/flux-oms/po-inbound/upload"
                            >{{ $t("UploadTxt") }}</a
                          >
                        </li>
                      </span>
                    </ul>
                  </div>
                  <div class="col-group col-md-2">
                    <p class="category-heading">{{ $t("inbound_asn") }}</p>
                    <ul class="submenu-item">
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'AsnController' && permision.method_read == 1
                          ">
                          <a class="nav-link" href="/flux-oms/asn-inbound">{{
                            $t("list")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'AsnController' && permision.method_create == 1
                          ">
                          <a
                            class="nav-link"
                            href="/flux-oms/asn-inbound/create"
                            >{{ $t("CreateTxt") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'AsnController' && permision.method_upload == 1
                          ">
                          <a
                            class="nav-link"
                            href="/flux-oms/asn-inbound/upload"
                            >{{ $t("UploadTxt") }}</a
                          >
                        </li>
                      </span>
                    </ul>
                  </div>
                  <div class="col-group col-md-2">
                    <p class="category-heading">{{ $t("interface") }}</p>
                    <ul class="submenu-item">
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'InterfaceBcaController' &&
                            permision.method_upload == 1
                          ">
                          <a class="nav-link" href="/flux-oms/interface/bca"
                            >BCA</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'InterfaceBasf01Controller' &&
                            permision.method_upload == 1
                          ">
                          <a class="nav-link" href="/flux-oms/interface/basf01"
                            >BASF Cimanggis</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'InterfaceBasf02Controller' &&
                            permision.method_upload == 1
                          ">
                          <a class="nav-link" href="/flux-oms/interface/basf02"
                            >BASF Cengkareng</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'InterfaceNldcController' &&
                            permision.method_upload == 1
                          ">
                          <a class="nav-link" href="/flux-oms/interface/nldc"
                            >NLDC</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'InterfaceSamsoniteController' &&
                            permision.method_upload == 1
                          ">
                          <a class="nav-link" href="/flux-oms/interface/map"
                            >MAP</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'InterfaceTumiController' &&
                            permision.method_upload == 1
                          ">
                          <a class="nav-link" href="/flux-oms/interface/tumi"
                            >TUMI</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'InterfaceGeneralController' &&
                            permision.method_upload == 1
                          ">
                          <a class="nav-link" href="/flux-oms/interface/general"
                            >General</a
                          >
                        </li>
                         <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'InterfaceYokeController' &&
                            permision.method_upload == 1
                          ">
                          <a class="nav-link" href="/flux-oms/interface/yoke"
                            >Yoke</a
                          >
                        </li>
                         <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'InterfaceBcafinController' &&
                            permision.method_upload == 1
                          ">
                          <a class="nav-link" href="/flux-oms/interface/bcafin"
                            >BCAFIN</a
                          >
                        </li>
                      </span>
                    </ul>
                  </div>
                </div>
              </div>
            </li>

            <!-- EXIM -->
            <li
              class="nav-item mega-menu"
              v-if="
                this.role == 'superadmin' ||
                this.role == 'superadmin_custom' ||
                this.user_type == 'EXIM'
              ">
              <a href="#" class="nav-link h4">
                <i class="link-icon mdi mdi-airplane-takeoff"></i>
                <span class="menu-title">{{ $t("ceisa") }}</span>
                <i class="link-arrow"></i>
              </a>
              <div class="submenu">
                <div class="col-group-wrapper row">
                  <div class="col-group col-md-2">
                    <p class="category-heading">{{ $t("master_data") }}</p>

                    <ul class="submenu-item">
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'CeisaSystemCodeController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/exim/ceisa/system-code">{{
                            $t("system_code")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'CeisaClientController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/exim/ceisa/client-login">{{
                            $t("client_login")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'CeisaPpjkController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/exim/ceisa/ppjk">{{
                            $t("ppjk")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'CeisaCustomerController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/exim/ceisa/customer">{{
                            $t("customer")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'CeisaSystemCodeController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/exim/ceisa/hs-code">{{
                            $t("hs_code")
                          }}</a>
                        </li>
                      </span>
                    </ul>
                  </div>

                  <div class="col-group col-md-2">
                    <p class="category-heading">{{ $t("dokumen_pabean") }}</p>

                    <ul class="submenu-item">
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'CeisaBarangImporController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/exim/ceisa/dokumen-pabean"
                            >{{ $t("list") }}</a
                          >
                        </li>
                      </span>
                    </ul>
                  </div>
                </div>
              </div>
            </li>

            <!-- WH Monitoring -->
            <li
              class="nav-item mega-menu"
              v-if="
                this.role == 'superadmin' ||
                this.role == 'superadmin_custom' ||
                this.user_type == 'WH_MNTR' || this.whMonitoring
              ">
              <a href="#" class="nav-link h4">
                <i class="link-icon mdi mdi-warehouse"></i>
                <span class="menu-title">Warehouse Monitoring</span>
                <i class="link-arrow"></i>
              </a>
              <div class="submenu">
                <div class="col-group-wrapper row">
                  <div class="col-group col-md-2">
                    <p class="category-heading">{{ $t("master_data") }}</p>

                    <ul class="submenu-item">
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'UserWhMonitoringMappingController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/wh-monitoring/user-mapping">{{
                            $t("txtUserMapping")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'WhMonitoringWarehouseController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/wh-monitoring/warehouse">{{
                            $t("fulfillment")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'WhMonitoringCustomerController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/wh-monitoring/customer">{{
                            $t("MasterCustomerTxt")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'WhMonitoringSystemCodeController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/wh-monitoring/system-code">{{
                            $t("systemCodeTxt")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'WhMonitoringEmployeeController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/wh-monitoring/employee">{{
                            $t("employeeTxt")
                          }}</a>
                        </li>
                      </span>
                    </ul>
                  </div>

                  <div class="col-group col-md-2">
                    <p class="category-heading">{{ $t("overTime") }}</p>
                    <ul class="submenu-item">
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'WhMonitoringCostCenterOvertimeController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/wh-monitoring/cost-overtime">{{
                            $t("masterOverTimeCost")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'WhMonitoringLogicOvertimeController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/wh-monitoring/logic-overtime">{{
                            $t("logicOvertimeTxt")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'WhMonitoringOvertimeController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/wh-monitoring/overtime">{{
                            $t("overTime")
                          }}</a>
                        </li>
                      </span>
                    </ul>
                  </div>
                  <div class="col-group col-md-2" v-show="this.userPermissions?.WhMonitoringWarehouseActivityController?.method_read || this.userPermissions?.WhMonitoringWarehouseActivityController?.method_custom1">
                    <p class="category-heading">{{ $t("whActivityTxt") }}</p>
                    <ul class="submenu-item">
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'WhMonitoringWarehouseActivityController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/wh-monitoring/wh-activity">{{
                            $t("list")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'WhMonitoringWarehouseActivityController' &&
                            permision.method_create == 1
                          ">
                          <a class="nav-link" href="/wh-monitoring/wh-activity/create">{{
                            $t("create")
                          }}</a>
                        </li>
                      </span>
                    </ul>
                  </div>
                  <div class="col-group col-md-2" v-show="this.userPermissions?.WhMonitoringDocumentHeaderController?.method_read || this.userPermissions?.WhMonitoringDocumentHeaderController?.method_custom1">
                    <p class="category-heading">{{ $t("whMonitoringDocumentPhoto") }}</p>
                    <ul class="submenu-item">
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'WhMonitoringDocumentHeaderController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/wh-monitoring/document-photo">{{
                            $t("list")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission.controller ==
                              'WhMonitoringDocumentHeaderController' &&
                            permision.method_create == 1
                          ">
                          <a class="nav-link" href="/wh-monitoring/document-photo/create">{{
                            $t("create")
                          }}</a>
                        </li>
                      </span>
                    </ul>
                  </div>
                </div>
              </div>
            </li>


            <!-- Sales Survey -->
            <li
              class="nav-item"
              v-if="
                this.role == 'superadmin' ||
                this.role == 'superadmin_custom' ||
                this.salesSurvey
              ">
              <a href="#" class="nav-link h4">
                <i class="link-icon" data-feather="bookmark"></i>
                <span class="menu-title">Survey</span>
                <i class="link-arrow"></i>
              </a>
              <div class="submenu">
                <ul class="submenu-item">
                  <li class="category-heading">V1</li>
                  <span
                    v-for="permision in permision_role"
                    :key="permision.permission_role_id">
                    <li
                      class="nav-item"
                      v-if="
                        permision.permission !== null &&
                        permision.permission.controller ==
                          'SalesSurveyController' &&
                        permision.method_read == 1
                      ">
                      <a class="nav-link" href="/sales-survey/cml"
                        >{{ $t("salesSurvey") }} CML</a
                      >
                    </li>
                    <li
                      class="nav-item"
                      v-if="
                        permision.permission !== null &&
                        permision.permission.controller ==
                          'SalesSurveyController' &&
                        permision.method_read == 1
                      ">
                      <a class="nav-link" href="/sales-survey/bp"
                        >{{ $t("salesSurvey") }} BP</a
                      >
                    </li>
                  </span>
                  <li class="category-heading">V2</li>
                  <span
                    v-for="permision in permision_role"
                    :key="permision.permission_role_id">
                    <li
                      class="nav-item"
                      v-if="
                        permision.permission !== null &&
                        permision.permission.controller ==
                          'SalesSurveyV2Controller' &&
                        permision.method_read == 1
                      ">
                      <a class="nav-link" href="/sales-survey/v2"
                        >{{ $t("salesSurvey") }}</a
                      >
                    </li>
                  </span>
                </ul>
              </div>
            </li>
 
            <li class="nav-item mega-menu" v-if="this.role == 'superadmin'">
              <a href="#" class="nav-link">
                <i class="link-icon" data-feather="settings"></i>
                <span class="menu-title">{{ $t("AdministrationTxt") }}</span>
                <i class="link-arrow"></i>
              </a>
              <div class="submenu">
                <div class="row">
                  <div class="col-md-4">
                    <ul class="submenu-item">
                      <li class="category-heading">Users Access Module</li>
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'CompanyController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/company">{{
                            $t("companyTxt")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'UserController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/user-access">{{
                            $t("txtUsers")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'RoleController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/role">{{
                            $t("txtRoles")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'PermissionController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/permission">{{
                            $t("txtPermission")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'PermissionRoleController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/rolpermis">{{
                            $t("txtPermissionRole")
                          }}</a>
                        </li>
                      </span>
                    </ul>
                  </div>
                  <div class="col-md-4">
                    <ul class="submenu-item">
                      <li class="category-heading">Users Mapping Flux OMS</li>
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'CompanyOMSController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/company-oms">{{
                            $t("companyOmsTxt")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'FulfillmentOMSController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/fulfillment-oms">{{
                            $t("fulfillmentOmsTxt")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'CompanyFulfillmentOMSController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/company-fulfillment-oms">{{
                            $t("companyAccessFulfillment")
                          }}</a>
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'UserOMSMappingController' &&
                            permision.method_read == 1
                          ">
                          <a class="nav-link" href="/user-oms">{{
                            $t("userAccessCompany")
                          }}</a>
                        </li>
                      </span>
                    </ul>
                  </div>

                  <div class="col-md-4">
                    <ul class="submenu-item">
                      <li class="category-heading">Users Mapping BLUJAY BCA</li>
                      <span
                        v-for="permision in permision_role"
                        :key="permision.permission_role_id">
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'LocationController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/blujay-bca/master-location"
                            >{{ $t("blujayBcaMasterLocationTxt") }}</a
                          >
                        </li>
                        <li
                          class="nav-item"
                          v-if="
                            permision.permission !== null &&
                            permision.permission.controller ==
                              'UserLocationController' &&
                            permision.method_read == 1
                          ">
                          <a
                            class="nav-link"
                            href="/blujay-bca/user-mapping-location"
                            >{{ $t("blujayBcaUserMappingLocationTxt") }}</a
                          >
                        </li>
                      </span>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <!-- partial -->
  </div>
</template>

<script>
import { setAuthLang } from "@/middleware/auth";
// import { clearSessionBillingToken } from "@/middleware/setBackendSessions";

export default {
  name: "navbarMenu",
  props: {},
  components: {},
  data() {
    return {
      locale: "",
      name: "",
      email: "",
      role: "",
      permision_role: [],
      branchDatas: [],
      user_type: "",
      billing_cli: 0,
      billing_cml: 0,
      billing_exim: 0,
      sales_force: 0,
      role_om: 0,
      salesSurvey: 0,
      whMonitoring: 0,
      fluxOms: 0,
      userPermissions: [],
      mapping_role_user_billing:0,
    };
  },
  watch: {},
  methods: {
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.name = userDatas.sub.name;
      this.email = userDatas.sub.email;
      this.role = userDatas.sub.role.name;
      this.user_type = userDatas.sub.user_type;
      this.permision_role = userDatas.sub.permision_role;

      let arr = [];

      this.permision_role.forEach((p)=>{
        const objKey = p.permission.controller;
        arr[objKey] = p;
      })

      this.userPermissions = arr;
      this.showMenu();
    },

    showMenu() {
      const userDatas = this.$getUserInfo();
      //let role_om_name = userDatas.sub.role.name;
      let array = userDatas.sub.permision_role;
      let billing_cli = 0;
      let billing_cml = 0;
      let billing_exim = 0;
      let sales_force = 0;
      let salesSurvey = 0;
      let mapping_role_user_billing = 0;
      let whMonitoring = 0;
      let fluxOms = 0;
      array.forEach((item) => {
        if (item.permission.controller == "BillingModuleCliAccess") {
          this.billing_cli = billing_cli += 1;
        }
        if (item.permission.controller == "BillingModuleCmlAccess") {
          this.billing_cml = billing_cml += 1;
        }
        if (item.permission.controller == "BillingModuleEximAccess") {
          this.billing_exim = billing_exim += 1;
        }
        if (item.permission.controller == "SalesForceModuleAccess") {
          this.sales_force = sales_force += 1;
        }
        if (item.permission.controller == "SalesSurveyController") {
          this.salesSurvey = salesSurvey += 1;
        }
        if (item.permission.controller == "MappingRoleUserBillingController") {
          this.mapping_role_user_billing = mapping_role_user_billing += 1;
        }
        if (item.permission.controller == "WhMonitoringMenuAccess") {
          this.whMonitoring = whMonitoring += 1;
        }
        if (item.permission.controller == "FluxOmsMenuAccess") {
          this.fluxOms = fluxOms += 1;
        }
      });

    //   let role_om = 0;
    //   if (role_om_name == "om_cml_basf01") {
    //     this.role_om = role_om += 1;
    //   } else {
    //     if (role_om_name == "om_cml_basf02_rm") {
    //       this.role_om = role_om += 1;
    //     } else {
    //       if (role_om_name == "om_cml_basf02_fg") {
    //         this.role_om = role_om += 1;
    //       }
    //     }
    //   }
    },

    linkToSettings() {
      window.location.href = "/settings";
    },

    langChanged(lang) {
      this.locale = lang;
      this.$i18n.locale = this.locale;
      localStorage.Lang = this.locale;
      setAuthLang(this.locale);
      // window.location.href = this.$route.fullPath;
      // console.log(this.$route)
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      // clearSessionBillingToken(localStorage.getItem(this.$settings.jwtSecret));

      this.$logoutUser();
      window.location.href = "/";
    },

    userProfile() {
      window.location.href = "/profile";
    },

    changePassword() {
      window.location.href = "/change-password";
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.langChanged(this.$i18n.locale);
  },
};
</script>
<style scoped></style>
